import client from '@/api/client';

import PAGINATION from '@sdk/helpers/misc/pagination';

import crudlModuleGenerator from '@/_CRUDL/modules/generator';

import { SORT_METHODS } from '@/_CRUDL/helpers/data/sort';

const CUSTOMER_STATUS_START = '_CRUDL/customers/status/start';
const CUSTOMER_STATUS_SUCCESS = '_CRUDL/customers/status/success';
const CUSTOMER_STATUS_FAILURE = '_CRUDL/customers/status/failure';

const CUSTOMER_ACTIVITY_LOG_START = '_CRUDL/customers/activity_log/start';
const CUSTOMER_ACTIVITY_LOG_SUCCESS = '_CRUDL/customers/activity_log/success';
const CUSTOMER_ACTIVITY_LOG_FAILURE = '_CRUDL/customers/activity_log/failure';

export const INITIAL_CUSTOMER_FILTERS = {
  CRUDL_append: false,
  name: '',
  cpf_cnpj: '',
  sort: SORT_METHODS.created_at_desc.value,
  page: 1,
  per_page: PAGINATION.PER_PAGE,
};

const customers = crudlModuleGenerator('customers');

export default {
  ...customers,
  actions: {
    ...customers.actions,
    find({ commit }, payload) {
      commit('_CRUDL/customers/read/START');

      return new Promise((resolve, reject) => {
        client.get('/customers/find', {
          params: {
            cpf_cnpj: payload.cpf_cnpj.trim(),
          },
        })
          .then((response) => {
            commit('_CRUDL/customers/read/SUCCESS', response);
            resolve(response);
          })
          .catch((error) => {
            commit('_CRUDL/customers/read/FAILURE', error);
            reject(error);
          });
      });
    },
    status({ commit }, payload) {
      commit(CUSTOMER_STATUS_START);

      return new Promise((resolve, reject) => {
        client.get(`/customers/${payload.id}/${payload.status}`)
          .then((response) => {
            commit(CUSTOMER_STATUS_SUCCESS, response);
            commit('_CRUDL/customers/read/SUCCESS', response);
            resolve(response);
          })
          .catch((error) => {
            commit(CUSTOMER_STATUS_FAILURE, error);
            commit('_CRUDL/customers/read/FAILURE', error);
            reject(error);
          });
      });
    },
    activity_log({ commit }, payload) {
      commit(CUSTOMER_ACTIVITY_LOG_START);

      return new Promise((resolve, reject) => {
        client.get(`/customers/${payload.id}/activity_log`)
          .then((response) => {
            commit(CUSTOMER_ACTIVITY_LOG_SUCCESS, response);
            resolve(response);
          })
          .catch((error) => {
            commit(CUSTOMER_ACTIVITY_LOG_FAILURE, error);
            reject(error);
          });
      });
    },
  },
  mutations: {
    ...customers.mutations,
    [CUSTOMER_STATUS_START](state) {
      state.status.error = null;
      state.status.loading = true;
    },
    [CUSTOMER_STATUS_SUCCESS](state) {
      state.status.error = null;
      state.status.loading = false;
    },
    [CUSTOMER_STATUS_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.status.error = details;
      state.status.loading = false;
    },
    [CUSTOMER_ACTIVITY_LOG_START](state) {
      state.activityLog.items = [];
      state.activityLog.error = null;
      state.activityLog.loading = true;
    },
    [CUSTOMER_ACTIVITY_LOG_SUCCESS](state, response) {
      state.activityLog.items = response.data.activity_log;
      state.activityLog.error = null;
      state.activityLog.loading = false;
    },
    [CUSTOMER_ACTIVITY_LOG_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.activityLog.error = details;
      state.activityLog.loading = false;
    },
  },
  state: {
    ...customers.state,
    status: {
      error: null,
      loading: false,
    },
    activityLog: {
      items: [],
      error: null,
      loading: false,
    },
    list: {
      ...customers.state.list,
      filters: {
        ...INITIAL_CUSTOMER_FILTERS,
      },
    },
  },
};
